/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (images) => ({
    type: actions.IMAGES_RECEIVE,
    payload: { images },
});